import './styles/override.less'
import './styles/global.less'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd from 'ant-design-vue'
import router from './router'
import store from './store'
import App from './App.vue'
import Datav from '@kjgl77/datav-vue3'
import VueLazyload from 'vue-lazyload'
import { preloadDirective } from '@/utils/lazyLoad.js'
import imgLoading from '@/assets/image/loading.gif'

import i18n from './utils/i18n'

import dayjs from "dayjs";

import "dayjs/locale/zh-cn";

dayjs.locale("zh-cn");

// 组件语言包统一在 App.vue 的 <a-config-provider :locale="zhCN"> 中注入

// const loadimage = require('./assets/loading.gif')
// const errorimage = require('./assets/error.gif')
// import { createI18n, } from 'vue-i18n'
// // 1. 导入语言包
// import en from '/src/assets/json/locales/en.json'
// import zh from '@/assets/json/locales/zh.json'
// import ml from '@/assets/json/locales/ml.json'
// import { useI18n } from 'vue-i18n'
// import Vue from 'vue'
// import lazyLoad from './utils/lazyLoad'
// import DataV from '@dataview/datav-vue3';
// import ElementPlus from 'element-plus'

// import 'element-plus/dist/index.css'
// Vue.directive('lazy', lazyLoad)
// 全局注册指令

// const i18n = createI18n({
//   legacy: true,          // 设置为 false，开启 Composition API 模式
//   locale: 'zh',           // 设置默认语言
//   fallbackLocale: 'zh',   // 设置回退语言，当当前语言缺失翻译时使用
//   globalInjection: true,
//   messages: {
//     en,
//     zh,
//     ml
//   }
// })


const app = createApp(App)

/**
 * 全局异常兜底。
 *
 * 已知框架竞态：Vue 3.5 的 <transition mode="out-in"> + <keep-alive> 组合，
 * 在路由快速切换 / 页面热更新时，旧页面的离场回调 afterLeave 会在 Transition
 * 实例已卸载后执行，框架内部读取 instance.job.flags 抛：
 *   TypeError: Cannot read properties of null (reading 'flags')
 * 此时页面其实已经切换完成，功能不受影响，但会弹出 runtime error 红屏。
 *
 * 这里只把这一条降级为 warn（保留堆栈便于排查），其余异常照常打印，
 * 避免把所有真实错误一起吞掉。
 */
app.config.errorHandler = (err, instance, hook) => {
  const msg = (err && err.message) || ''
  if (msg.indexOf("reading 'flags'") > -1) {
    console.warn('[Vue] 已忽略过渡动画的框架竞态异常（页面切换完成后触发，不影响功能）：', msg)
    return
  }
  console.error('[Vue error]', hook, err)
}


app.directive('lazy', preloadDirective)

const pinia = createPinia()
// app.use(ElementPlus, { size: 'small', zIndex: 3000 })
// app.use(ElementPlus)
app.use(pinia)
app.use(store)
app.use(router)
app.use(Antd, {
  theme: {
    primaryColor: '#5E8BFF',
  },
})
app.use(Datav);
app.use(i18n)
app.use(VueLazyload, {
  preLoad: 1.3,
  loading: imgLoading,
  attempt: 1
})

// vue注册Antd并挂载应用
app.mount('#app')